<span class="badge"
  [style.font-size]="fontSize"
  [class.badge-draft]="status === 1"
  [class.badge-pending]="status === 2"
  [class.badge-in-progress]="status === 3"
  [class.badge-completed]="status === 4"
  [class.badge-canceled]="status === 5"
  [class.badge-rejected]="status === 6">
  {{ textStatus }}
</span>